var exports = {
  "Tj": "xaf9ae18d--964598--map",
  "_8": "xaf9ae18d--964598--img",
  "y_": "xaf9ae18d--964598--pin",
  "yl": "xaf9ae18d--964598--modal",
};

module.exports = exports;
